import { h, Fragment } from 'preact'
import { useLayoutEffect } from 'preact/hooks'
import { setAllToMaxHeight } from '../../js/modules/setAllToMaxHeight.js'

export const BandeParcoursMarchand = ({ title, recommendations, pill, eventId }) => {
   useLayoutEffect(() => {
      setAllToMaxHeight('.btn-custom-height')
   }, [])

   return (
      <div class="container-fluid">
         <div class="row mb-0 mb-xl-2 marchand_parcours" data-testid={eventId === 'parcoursNouveaute' ? 'bande-parcours-nouveaute' : 'bande-parcours-marchand'}>
            <div class="col-12">
               <h2 class="mb-1 mw-100">{title}</h2>

               {pill && pill !== '' ? (
                  <div class="mb-2 mw-100" data-testid="intitule-contrat-logue">
                     <span class="ob1-capsule ob1-capsule-context">{pill}</span>
                  </div>
               ) : (
                  ''
               )}

               <div class="row slider-parcours">
                  {recommendations.map((recommendation, index) => {
                     return (
                        <Fragment>
                           {!recommendation.displayType || recommendation.displayType === '' || recommendation.displayType === 'classic' ? (
                              <Recommendation {...recommendation} index={index + 1} eventId={eventId} />
                           ) : (
                              ''
                           )}
                           {recommendation.displayType === 'highlight' ? <RecommendationHighlight {...recommendation} index={index + 1} eventId={eventId} /> : ''}
                        </Fragment>
                     )
                  })}
               </div>
            </div>
         </div>
      </div>
   )
}

const Recommendation = ({ image, alt, title, description, CTA, index, eventId }) => {
   let adviseTags = {}
   if (CTA.analytics.advCappingdata !== '' && CTA.analytics.advCanal !== '' && CTA.analytics.pdbTa !== '') {
      adviseTags = {
         'data-pdb-ta': CTA.analytics.pdbTa,
         'data-adv-canal': CTA.analytics.advCanal,
         'data-adv-cappingdata': CTA.analytics.advCappingdata,
      }
   }
   return (
      <div class="col-12 col-lg-3">
         <div
            class="card ob1-push ob1-push-shadow-right ob1-push-md-shadow-left"
            data-testid={`${eventId}${index}`}
            data-pdb-zid={CTA.analytics.pdbZid}
            data-pdb-sc={CTA.analytics.pdbSc}
            data-pdb-idc={CTA.analytics.pdbIdc}
            data-pdb-vi={CTA.analytics.pdbVi}
            {...adviseTags}
            data-oevent-category={CTA.analytics.oeventCategory}
            data-oevent-action={CTA.analytics.oeventAction}
            data-oevent-label={CTA.analytics.oeventLabel}
            data-oevent-other={CTA.analytics.oeventOther}
         >
            <div class="card-header">
               <picture>
                  <source srcset={`${image}?format=390x260&crop=630,354,0,1&saveas=webp`} media="(max-width: 419px)" />
                  <source srcset={`${image}?format=425x283&saveas=webp`} media="(max-width: 959px)" />
                  <source srcset={`${image}?format=523x349&saveas=webp`} media="(max-width: 1199px)" />
                  <img src={`${image}?format=293x195&saveas=webp`} alt={alt} class="card-img-top w-100" loading="lazy" />
               </picture>
            </div>
            <div class="card-body">
               <h3 class="lead font-weight-bold w-75 mb-0" data-clamp="2">
                  {title}
               </h3>
               <p class="card-text">{description}</p>
               <p class="py-0 card-btn">
                  <a href={CTA.URL} class="btn btn-secondary btn-custom-height">
                     {CTA.label}
                  </a>
               </p>
            </div>
         </div>
      </div>
   )
}

const RecommendationHighlight = ({ image, alt, title, description, CTA, index, badge, eventId }) => {
   return (
      <div class="col-12 col-lg-3">
         <div class="h-100 pb-2 pb-md-3">
            <div
               class="ob1-card ob1-card-inverse lien-composite-before mb-2 h-100"
               data-testid={`${eventId}${index}`}
               data-pdb-zid={CTA.analytics.pdbZid}
               data-pdb-sc={CTA.analytics.pdbSc}
               data-pdb-idc={CTA.analytics.pdbIdc}
               data-pdb-vi={CTA.analytics.pdbVi}
               data-pdb-ta={CTA.analytics.pdbTa}
               data-adv-canal={CTA.analytics.advCanal}
               data-adv-cappingdata={CTA.analytics.advCappingdata}
               data-oevent-category={CTA.analytics.oeventCategory}
               data-oevent-action={CTA.analytics.oeventAction}
               data-oevent-label={CTA.analytics.oeventLabel}
               data-oevent-other={CTA.analytics.oeventOther}
            >
               {badge !== '' ? <strong class="ob1-tag ob1-tag-inverse ob1-tag-primary">{badge}</strong> : ''}
               <picture>
                  <source srcset={`${image}?format=390x260&saveas=webp`} media="(max-width: 419px)" />
                  <source srcset={`${image}?format=425x283&saveas=webp`} media="(max-width: 959px)" />
                  <source srcset={`${image}?format=523x349&saveas=webp`} media="(max-width: 1199px)" />
                  <img src={`${image}?format=293x195&saveas=webp`} alt={alt} class="card-img-top w-100" loading="lazy" />
               </picture>
               <div class="card-header">
                  <h3 class="lead font-weight-bold text-primary2 text-center p-0 mb-1 mt-1">{title}</h3>
                  <p class="lead font-weight-bold mt-1 pt-0 text-center">{description}</p>
                  <a href={CTA.URL} class="o-link-arrow mb-1 mx-auto o-link-reverse text-center">
                     {CTA.label}
                  </a>
               </div>
            </div>
         </div>
      </div>
   )
}
